import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./twb.css";

const Market = (props) => {
  const { className } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const closeBtn = (
    <button className='close' onClick={toggle}>
      &times;
    </button>
  );

  return (
    <div>
      <button className='button' onClick={toggle}>
        See the project
      </button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Modal title
        </ModalHeader>
        <ModalBody className='modalBody'>
          <img
            src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614136718/FireShot_Pro_Webpage_Screenshot_015_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_vssfka.png'
            alt='img'
          />
          <h2>Market Place</h2>
          <div className='tag-body-single'>
            <div className='tags'>Html</div>
            <div className='tags'>Css</div>
            <div className='tags'>Javascript</div>
          </div>
          <p>
            This is the homepage UI of a Market place ecommernce website built
            with Html, Css and Javascript which displays categories and products
          </p>
          <div className='tag-body-live'>
            <div className='tag one'>
              <a
                href='https://zcpi-marketplace-page.netlify.app/'
                target='_blank'
              >
                See live
              </a>
            </div>
            <div className='tag two'>
              <a
                href='https://github.com/Elijahscriptdev/market-place'
                target='_blank'
              >
                see code
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Market;
